import { AppResponse } from 'src/models/app-response';
import { Role, User } from 'src/models/user';
import axios from 'src/utils/axios';
import { endpoints } from 'src/utils/api-endpoints';
import { MyDashboardData } from 'src/types/mydashboard';


export async function createUser(userData: User): Promise<AppResponse<User>> {
  const url = endpoints.user.addUser;
  try {
    const response = await axios.post<AppResponse<User>>(url, userData);
    return response.data;
  } catch (error) {
    console.error('Failed to create user:', error);
    throw error;
  }
}
// ----------------------------------------------------------------------

export async function getAllUsers(): Promise<AppResponse<User[]>> {
  const url = endpoints.user.getAllUsers;
  try {
    const response = await axios.get<AppResponse<User[]>>(url);
    return response.data;
  } catch (error) {
    console.error('Error fetching users:', error);
    return {success: false, data: [], error };
  }
}
// ----------------------------------------------------------------------


export async function getUsersByOrganization(_id: string): Promise<AppResponse<User[]>> {
  const url = `${endpoints.user.getUsersByOrganization}/${_id}`;
  try {
    const response = await axios.get<AppResponse<User[]>>(url);
    return response.data;
  } catch (error) {
    console.error('Error fetching users:', error);
    return {success: false, data: [], error };
  }
}


// ----------------------------------------------------------------------
export async function updateUser(userData: Partial<User> & {_id: string}): Promise<AppResponse<User>> {
  const url = endpoints.user.editUser;
  delete userData.jobRoles;
  const response = await axios.post<AppResponse<User>>(url, userData);
  return response.data;
}

export async function deleteUser(_id: string): Promise<AppResponse<User>> {
  const URL = `${endpoints.user.deleteUser}/${_id}`;
  const response = await axios.delete(URL);
  return response.data;
}

// ----------------------------------------------------------------------

export async function updatePassword(oldPassword: string, newPassword: string): Promise<AppResponse<null>> {
  const url = `${endpoints.user.updatePassword}`;
  try {
    const response = await axios.post<AppResponse<null>>(url, { oldPassword, newPassword });
    return response.data;
  } catch (error) {
    console.error('Error updating password:', error);
    throw error;
  }
}
// ----------------------------------------------------------------------
export async function setPassword(token: string, password: string): Promise<AppResponse<{email: string}>> {
  const url = `${endpoints.user.setPassword}`;
  try {
    const response = await axios.post<AppResponse<{email: string}>>(url, { token, password });
    return response.data;
  } catch (error) {
    console.error('Error updating password:', error);
    throw error;
  }
}

export async function getAllSuperAdmins(): Promise<AppResponse<User[]>> {
  const url = endpoints.user.getAllSuperAdmins;
  try {
    const response = await axios.get<AppResponse<User[]>>(url);
    return response.data;
  } catch (error) {
    console.error('Error fetching super admins:', error);
    return { success: false, data: [], error };
  }
}

export async function resendInvitation(userId: string): Promise<AppResponse<null>> {
  const url = `${endpoints.user.resendInvitation}/${userId}`;
  try {
    const response = await axios.post<AppResponse<null>>(url);
    return response.data;
  } catch (error) {
    console.error('Error resending invitation:', error);
    throw error;
  }
}

export async function updateUserRole(userId: string, role: Role): Promise<AppResponse<User>> {
  const url = endpoints.user.updateRole(userId);
  try {
    const response = await axios.put<AppResponse<User>>(url, { role });
    return response.data;
  } catch (error) {
    console.error('Failed to update role:', error);
    throw error;
  }
}

export async function updateUserJobRoles(userId: string, jobRoleIds: string[]): Promise<AppResponse<User>> {
  const url = endpoints.user.updateJobRoles(userId);
  try {
    const response = await axios.put<AppResponse<User>>(url, { jobRoleIds });
    return response.data;
  } catch (error) {
    console.error('Failed to update job roles:', error);
    throw error;
  }
}

export async function getMyDashboard(): Promise<AppResponse<MyDashboardData>> {
  const url = endpoints.user.getMyDashboard;
  try{
    const response = await axios.get<AppResponse<MyDashboardData>>(url);
    return response.data;
  } catch(error){
    console.error('Error Fetching my Dashboard: ',error)
    return {success: false, data: undefined, error}
  }
}